import Blog from "./blog";
import { h, render } from "preact";

class SectionMainBlog extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-container]");
    render(<Blog data={this.data} />, this.container);
  }
}

if (!customElements.get("section-main-blog")) {
  customElements.define("section-main-blog", SectionMainBlog);
}
